import { useEffect, useState, useRef } from "react";
// import axios from "axios";
import {
  Card,
  Typography,
  Button,
  Box,
  CircularProgress,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../context/AuthContext";
import { useQuery } from "@apollo/client";
import { GET_MEMBER_DETAILS } from "../graphql/queries";
import TKSMemberCard from "./TKSMemberCard";
import NotLoggedIn from "../components/LoginExceptions";
import { useLocation } from "react-router-dom";

const MembershipIDCard = () => {
  const location = useLocation();
  const passedMember = location.state?.user;
  const [mobile, setMobile] = useState(passedMember?.Mobile_Number || "");
  // const navigate = useNavigate();
  // const { user } = useAuth();
  const cardRef = useRef(null);
  const hiddenCardRef = useRef(null);
  const storedUserType = localStorage.getItem("user_type");
  window.scrollTo(0, 0);

  useEffect(() => {
    const storedMobile = localStorage.getItem("mobile");
    if (storedMobile && !passedMember) setMobile(storedMobile);
  }, [passedMember]);

  const { loading, error, data, refetch } = useQuery(GET_MEMBER_DETAILS, {
    variables: { mobile },
    skip: !mobile || !!passedMember, // ✅ skip query if passed member is available
    fetchPolicy: "network-only",
  });  
  
  useEffect(() => {
    if (mobile && !passedMember) {
      refetch();
    }
  }, [mobile, refetch, passedMember]);  

  const member = passedMember || data?.zoneMember;
  // const storedUser = localStorage.getItem("first_name");

  const mandatoryFields = [
    "Family_Details",
    // "Email",
    "Occupation",
    "Address",
    "Marital_Status",
    "ID_Proof_Type",
    "ID_Proof_Number",
  ];

  // const isDataIncomplete = mandatoryFields.some(
  //   (field) => !member?.[field] || member?.[field] === ""
  // );

  const isPanCardNo = member?.Pan_Card === "No";
  // const isPanDetailsMissing =
  //   isPanCardNo && (!member?.Pan_Number || member?.Pan_Number === "");

  // const isPaymentPending = member?.Payment_Status !== "Paid";

  const handleDownload = async () => {
    const element = hiddenCardRef.current;

    // Set fixed dimensions for the hidden card before capturing
    if (element.parentElement) {
      element.parentElement.style.width = "600px"; // Fixed width for consistent output
    }

    const canvas = await html2canvas(element, {
      scale: 3,
      useCORS: true,
      logging: false,
      windowWidth: 1200 // Force desktop-like rendering
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: [92, 60],
    });

    pdf.addImage(imgData, "PNG", 0, 0, 92, 60);
    
    // Use member name in filename if available
      const fileName = member?.NAME ? 
        `${member.NAME}_Membership_ID_Card.pdf` : 
        "Membership_ID_Card.pdf";
    
    pdf.save(fileName);
  };

  if (!storedUserType) return <NotLoggedIn />;

  console.log(data);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="flex-start"
      bgcolor="#f4f4f4"
      px={{ xs: 2, sm: 3 }}
      sx={{
        backgroundColor: "#f8f9e9",
        py: 10,
        minHeight: "80vh", // 🔑 Ensures space is reserved for content
        boxSizing: "border-box",
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: "500",
          color: "#2A289C",
          textAlign: "center",
          fontSize: "32px",
        }}
        gutterBottom
      >
        Membership ID Card
      </Typography>

      {loading && (
        <Box mt={6}>
          <CircularProgress />
        </Box>
      )}

      {/* === Error State === */}
      {!loading && error && (
        <Typography color="error" mt={4}>
          Error: {error.message}
        </Typography>
      )}


      
      {/* === No Data State === */}
      {!loading && !error && !data?.zoneMember  && (
        <Typography color="textSecondary" mt={4}>
          No data found.
        </Typography>
      )}

      {/* === Conditional Rendering of Message / Card === */}
      {!loading && member && (
        <>
          { (
            <Card
              sx={{
                mt: 4,
                width: "fit-content",
                p: 2,
                backgroundColor: "#fff",
                borderRadius: 3,
                position: "relative",
                boxShadow: 4,
              }}
            >
              {/* Top-right download button */}
              <Box
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Button
                  color="black"
                  size="small"
                  startIcon={<DownloadIcon />}
                  onClick={handleDownload}
                  sx={{
                    textTransform: "none",
                    fontWeight: "bold",
                    color: "#333",
                    px: 2,
                    borderRadius: "8px",
                    backgroundColor: "#f5f5f5",
                    transition: "all 0.3s ease",
                    '&:hover': {
                      background: "linear-gradient(135deg, #B4AB57, #947F49)",
                      color: "#fff",
                      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
                    },
                  }}
                >
                  Download
                </Button>
              </Box>

              {/* Member Card */}
              <Box ref={cardRef} display="flex" justifyContent="center" mt={4}>
                <TKSMemberCard member={member} />
              </Box>

              {/* Hidden Member Card for Download (always desktop size) */}
              <div style={{ position: 'absolute', left: '-9999px', top: 0, width: '600px', overflow: 'hidden' }}>
                <Box ref={hiddenCardRef} sx={{ width: '100%' }}>
                  <TKSMemberCard member={member} forDownload={true} />
                </Box>
              </div>
            </Card>
          )}
        </>
      )}
    </Box>
  );
};

export default MembershipIDCard;